<template>
    <qd-admin-auth pid="41">
        <div class="corpinfo">
            <CorpExpireMask />
            <div v-if="isEdit">
                <edit-related v-if="!isMainCorp" :industrylist="industry_list" :corp-admin="corp_admin" :edit-info="info" @goBack="goBack" />
                <edit-main v-else :industrylist="industry_list" :corp-admin="corp_admin" :edit-info="info" @goBack="goBack" />
            </div>
            <list v-else :industrylist="industryObj" :corp-admin="corp_admin" :combos-info="combosInfo" @edit="edit" />
        </div>
    </qd-admin-auth>
</template>
<script>
import { isPrivate } from 'src/config/private';
import CorpExpireMask from 'src/components/corp-expire-mask';
import editRelated from './pages/edit-related.vue';
import list from './pages/list.vue';
import editMain from './pages/edit-main.vue';
export default {
    components: {
        editRelated,
        list,
        editMain,
        CorpExpireMask,
    },
    data() {
        return {
            corp_admin: {
                // 是否需要审核
                need_verify: true,
                // 是否需要上传附件送审
                need_attachment: true,
                // 是否需要验证手机号 和 手机验证码
                need_sms_code: true,
                // 是否需要关联企业
                need_related_corp: true,
            },
            industry_list: [],
            industryObj: {},
            combosInfo: {},
            isEdit: false,
            info: {},
            isMainCorp: false,
        };
    },
    async created() {
        if (isPrivate) {
            // 私有化环境判断展示隐藏
            await this.getPrivateCorpFlag();
        }
        // 拉取套餐信息（套餐名翻译已合并进 vue-i18n，启动期 bootstrap 已统一加载）
        this.getCombos();
        // 获取行业信息
        this.getAccountIndustry();
    },
    methods: {
        goBack() {
            this.isEdit = false;
        },
        edit(data) {
            this.isEdit = true;
            this.info = data.info;
            this.isMainCorp = data.type === 1;
        },
        getPrivateCorpFlag() {
            this.$ajax.post('/mng/account/corpInfo/getPrivateCorpFlag').then((res) => {
                const { data } = res;
                this.corp_admin = data.corp_admin || this.corp_admin;
            });
        },
        getCombos() {
            this.$ajax.get('/mng/account/index/extCorpInfo').then((res) => {
                const { data } = res;
                this.combosInfo = data || this.combosInfo;
            });
        },
        getAccountIndustry() {
            // ajax 层会自动在请求前等待翻译字典就绪，
            // 因此 then 回调里直接用 $t 翻译即可，无须业务侧等待。
            this.$ajax.gatewayGet('/v1/basic/corp/corp/industryInfo').then((res) => {
                const { data } = res;
                const rawList = data.industry_all || [];
                const industryList = this.translateIndustryList(rawList);
                this.industryObj = industryList;
                this.parseData(industryList);
            });
        },
        // 递归翻译 industryInfo 返回结构中的 name 字段（保留原结构）
        translateIndustryList(list) {
            const tran = v => (typeof v === 'string' ? this.$t(v) : v);
            const cloneAndTranslate = (item) => {
                if (!item || typeof item !== 'object') return item;
                const next = { ...item };
                if (typeof next.name === 'string') next.name = tran(next.name);
                if (next.sub && typeof next.sub === 'object') {
                    const subOut = Array.isArray(next.sub) ? [] : {};
                    Object.keys(next.sub).forEach((k) => {
                        subOut[k] = cloneAndTranslate(next.sub[k]);
                    });
                    next.sub = subOut;
                }
                return next;
            };
            if (Array.isArray(list)) return list.map(cloneAndTranslate);
            // 后端可能用对象形式返回（key 为 id），保留 key 结构
            const out = {};
            Object.keys(list).forEach((k) => {
                out[k] = cloneAndTranslate(list[k]);
            });
            return out;
        },
        parseData(data) {
            const industry = [];
            industry.push({
                text: this.$t('全部分类'),
                value: -3,
                children: [{
                    text: this.$t('全部分类'),
                    value: -2,
                }],
            });
            for (let i = 0; i < Object.values(data).length; i++) {
                const item = Object.values(data)[i];
                if (item.display === '1') {
                    const cur = {
                        value: Number(item.id),
                        text: item.name,
                        children: [],
                    };
                    if (item.sub) {
                        const sub = cur.children;
                        for (let j = 0; j < Object.values(item.sub).length; j++) {
                            const subItem = Object.values(item.sub)[j];
                            if (subItem.display === '1') {
                                sub.push({
                                    value: Number(subItem.id),
                                    text: subItem.name,
                                });
                            }
                        }
                    }
                    cur.children.unshift({
                        text: this.$t('全部分类'),
                        value: -2,
                    });
                    industry.push(cur);
                }
            }
            this.industry_list = industry;
        },
    },
};
</script>
<style lang="less" scoped>
.qidian-admin-auth {
    height: calc(100vh - 120px);
}
</style>
